/**
 * ArticlePage2 Component
 * Replicates ArticlePage layout
 */
export class ArticlePage2 {
    constructor(containerId, articleData = null) {
        this.containerId = containerId;
        // Default dummy data if none provided
        this.articleData = articleData || {
            headline: "Article 2 Headline Placeholder",
            author: "footballgirl",
            date: "October 24, 2023",
            imageGradient: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
            content: `
                <p>This is the content for Article 2. It replicates the layout of the main article page.</p>
                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
            `
        };
        this.navIndices = this.articleData.navIndices || { prev: 'wsl-1', next: 'wsl-3' };
        this.element = null;
        this.isLoggedIn = false;
    }

    init() {
        console.log('ArticlePage2 initialized');
        this.element = document.getElementById(this.containerId);

        // If specific container not found, try to find the main content area to replace
        if (!this.element) {
             this.element = document.querySelector('.content-area');
        }
        
        if (this.element) {
            this.injectStyles();
            this.render();
        } else {
            console.error('ArticlePage2: Container not found');
        }
    }

    injectStyles() {
        const styleId = 'article-page-styles-v2';
        if (document.getElementById(styleId)) return;

        const css = `
            .article-view {
                max-width: 800px;
                margin: 0 auto;
                padding: 20px;
                background: #fff;
                min-height: 100vh;
                box-sizing: border-box;
                animation: fadeIn 0.3s ease;
                box-shadow: 0 4px 20px rgba(0,0,0,0.08);
            }
            
            @keyframes fadeIn {
                from { opacity: 0; transform: translateY(10px); }
                to { opacity: 1; transform: translateY(0); }
            }

            .hero-overlay-btn {
                position: absolute;
                top: 16px;
                z-index: 100;
                background: rgba(0, 0, 0, 0.6);
                color: white;
                border-radius: 20px;
                padding: 8px 16px;
                text-decoration: none;
                font-size: 13px;
                font-weight: 600;
                backdrop-filter: blur(4px);
                display: flex;
                align-items: center;
                cursor: pointer;
                border: none;
                transition: background 0.2s;
                white-space: nowrap;
            }
            .hero-overlay-btn:hover {
                background: rgba(0, 0, 0, 0.8);
            }

            .hero-back-btn { left: 16px; }
            .hero-util-btn { right: 16px; padding: 8px; border-radius: 50%; }

            .article-header {
                margin-bottom: 30px;
            }

            .article-title {
                font-size: 32px;
                font-weight: 800;
                line-height: 1.2;
                color: #111;
                margin: 0 0 20px 0;
            }

            .article-meta {
                display: flex;
                align-items: center;
                color: #777;
                font-size: 14px;
                margin-bottom: 30px;
            }
            .meta-separator { margin: 0 8px; }

            .share-row {
                display: flex;
                gap: 12px;
                margin-bottom: 20px;
            }
            .share-icon {
                width: 36px;
                height: 36px;
                background: #f5f6f8;
                border-radius: 50%;
                display: flex;
                align-items: center;
                justify-content: center;
                color: #333;
                cursor: pointer;
                transition: background 0.2s;
            }
            .share-icon:hover { background: #e5e5e5; }

            .tags-row {
                display: flex;
                flex-wrap: wrap;
                gap: 8px;
                margin-bottom: 20px;
            }
            .tag-pill {
                background: #f5f6f8;
                padding: 6px 14px;
                border-radius: 20px;
                font-size: 12px;
                font-weight: 600;
                color: #555;
            }

            .article-hero {
                position: relative;
                width: 100%;
                height: 400px;
                border-radius: 12px;
                margin-bottom: 30px;
                background-size: cover;
                background-position: center;
                display: flex;
                align-items: center;
                justify-content: center;
                color: rgba(255,255,255,0.8);
                font-weight: 500;
                font-size: 18px;
            }

            .article-content {
                font-size: 18px;
                line-height: 1.6;
                color: #333;
            }
            .article-content p {
                margin-bottom: 20px;
            }

            .footer-card {
                margin-top: 40px;
                padding: 32px;
                background: #f8f9fa;
                border-radius: 16px;
                text-align: center;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
            }
            .footer-card-logo {
                height: 88px;
                width: auto;
                margin-bottom: 12px;
            }
            .footer-card-text {
                font-size: 1.1rem;
                font-weight: 700;
                color: #111;
                margin: 0;
            }

            .article-navigation {
                display: flex;
                justify-content: flex-end;
                margin-top: 20px;
            }
            .nav-arrow-btn {
                width: 48px;
                height: 48px;
                border-radius: 50%;
                background: #f0f2f5;
                border: none;
                display: flex;
                align-items: center;
                justify-content: center;
                cursor: pointer;
                transition: all 0.2s ease;
                color: #333;
                box-shadow: 0 2px 5px rgba(0,0,0,0.1);
            }
            .nav-arrow-btn:hover {
                background: #e4e6eb;
                transform: translateX(4px);
            }
            #prevArticleBtn:hover {
                transform: translateX(-4px);
            }

            /* Comments Section */
            .comments-section {
                margin-top: 40px;
                border-top: 1px solid #eee;
                padding-top: 30px;
            }
            .comments-header {
                font-size: 20px;
                font-weight: 700;
                margin-bottom: 20px;
                color: #111;
            }
            .comment-list {
                display: flex;
                flex-direction: column;
                gap: 20px;
                margin-bottom: 30px;
            }
            .comment-item {
                display: flex;
                gap: 12px;
            }
            .comment-avatar {
                width: 40px;
                height: 40px;
                border-radius: 50%;
                background: #f0f2f5;
                display: flex;
                align-items: center;
                justify-content: center;
                font-weight: 600;
                color: #555;
                flex-shrink: 0;
                font-size: 14px;
            }
            .comment-body {
                flex: 1;
            }
            .comment-author {
                font-weight: 600;
                font-size: 14px;
                margin-bottom: 4px;
                color: #111;
            }
            .comment-text {
                font-size: 14px;
                color: #333;
                line-height: 1.4;
            }
            .comment-meta {
                font-size: 12px;
                color: #888;
                margin-top: 4px;
            }
            .comment-form-container {
                background: #f9f9f9;
                padding: 20px;
                border-radius: 12px;
            }
            .auth-prompt {
                text-align: center;
                padding: 30px;
                background: #f8f9fa;
                border-radius: 12px;
                color: #555;
                font-size: 15px;
            }
            .auth-btn {
                background: #1877f2;
                color: white;
                border: none;
                padding: 6px 12px;
                border-radius: 6px;
                font-weight: 600;
                cursor: pointer;
                margin: 0 4px;
                font-size: 14px;
            }
            .auth-btn:hover {
                background: #166fe5;
            }
            .comment-textarea {
                width: 100%;
                padding: 12px;
                border: 1px solid #ddd;
                border-radius: 8px;
                resize: vertical;
                min-height: 80px;
                margin-bottom: 10px;
                font-family: inherit;
                box-sizing: border-box;
            }
            .comment-textarea:focus {
                outline: none;
                border-color: #1877f2;
            }
            .post-btn {
                background: #1877f2;
                color: white;
                border: none;
                padding: 8px 20px;
                border-radius: 6px;
                font-weight: 600;
                cursor: pointer;
                font-size: 14px;
            }
            .post-btn:hover {
                background: #166fe5;
            }

            @media (max-width: 768px) {
                .article-title {
                    font-size: 24px;
                }
                .article-hero {
                    height: 250px;
                }
            }
        `;

        const style = document.createElement('style');
        style.id = styleId;
        style.textContent = css;
        document.head.appendChild(style);
    }

    render() {
        // Clear existing content
        this.element.innerHTML = '';
        
        // Destructure with defaults for new fields
        const { headline, author, date, imageGradient, image, content, tags, readingTime } = {
            tags: ['Football', 'WSL', 'Man City'],
            readingTime: '4 min read',
            image: null,
            ...this.articleData
        };

        // Mock comments data
        const comments = [
            { author: "Sarah J.", text: "Great appointment! Can't wait to see what he brings to the team.", time: "2 hours ago", initials: "SJ" },
            { author: "Mike T.", text: "Hopefully this stabilizes the defense.", time: "5 hours ago", initials: "MT" }
        ];

        const commentsHtml = comments.map(c => `
            <div class="comment-item">
                <div class="comment-avatar">${c.initials}</div>
                <div class="comment-body">
                    <div class="comment-author">${c.author}</div>
                    <div class="comment-text">${c.text}</div>
                    <div class="comment-meta">${c.time}</div>
                </div>
            </div>
        `).join('');

        const commentFormHtml = this.isLoggedIn ? `
            <div class="comment-form-container">
                <textarea class="comment-textarea" placeholder="Write a comment..."></textarea>
                <button class="post-btn">Post Comment</button>
            </div>
        ` : `
            <div class="auth-prompt">
                Please <button class="auth-btn" id="signInBtn">Sign In</button> to post a comment.
            </div>
        `;

        this.element.innerHTML = `
            <div class="article-view">
                <div class="article-hero" style="background-image: ${image ? `url('${image}')` : imageGradient};">
                    <a href="/" class="hero-overlay-btn hero-back-btn" id="articleBackBtn">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width: 16px; height: 16px; margin-right: 6px;">
                            <line x1="19" y1="12" x2="5" y2="12"></line>
                            <polyline points="12 19 5 12 12 5"></polyline>
                        </svg>
                        Back to WSL
                    </a>
                    <div class="hero-overlay-btn hero-util-btn" style="background: white; padding: 6px; cursor: default;">
                        <img src="/images/league_wsl.png" alt="WSL" style="width: 24px; height: 24px; object-fit: contain; display: block;">
                    </div>
                </div>

                <h1 class="article-title">${headline}</h1>

                <div class="share-row">
                    <div class="share-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width: 16px; height: 16px;"><path d="M23 3a10.9 10.9 0 0 1-3.14 1.53 4.48 4.48 0 0 0-7.86 3v1A10.66 10.66 0 0 1 3 4s-4 9 5 13a11.64 11.64 0 0 1-7 2c9 5 20 0 20-11.5a4.5 4.5 0 0 0-.08-.83A7.72 7.72 0 0 0 23 3z"></path></svg></div>
                    <div class="share-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width: 16px; height: 16px;"><path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"></path></svg></div>
                    <div class="share-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width: 16px; height: 16px;"><path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"></path><path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"></path></svg></div>
                </div>

                <div class="tags-row">
                    ${tags.map(tag => `<span class="tag-pill">${tag}</span>`).join('')}
                </div>

                <div class="article-meta">
                    <span>${date}</span>
                    <span class="meta-separator">•</span>
                    <span>${readingTime}</span>
                    <span class="meta-separator">•</span>
                    <span>By ${author}</span>
                </div>

                <div class="article-content">
                    ${content}
                </div>

                <!-- AdSense Responsive Unit -->
                <div style="margin: 40px 0; text-align: center; width: 100%;">
                    <ins class="adsbygoogle"
                         style="display:block; text-align:center;"
                         data-ad-layout="in-article"
                         data-ad-format="fluid"
                         data-ad-client="ca-pub-7705230222200385"
                         data-ad-slot="1708603458"></ins>
                </div>

                <div class="comments-section">
                    <h3 class="comments-header">Comments (${comments.length})</h3>
                    <div class="comment-list">
                        ${commentsHtml}
                    </div>
                    ${commentFormHtml}
                </div>

                <div class="article-navigation" style="justify-content: space-between;">
                    <button id="prevArticleBtn" class="nav-arrow-btn" aria-label="Previous Article">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width: 24px; height: 24px;">
                            <line x1="19" y1="12" x2="5" y2="12"></line>
                            <polyline points="12 19 5 12 12 5"></polyline>
                        </svg>
                    </button>
                    <button id="nextArticleBtn" class="nav-arrow-btn" aria-label="Next Article">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width: 24px; height: 24px;">
                            <line x1="5" y1="12" x2="19" y2="12"></line>
                            <polyline points="12 5 19 12 12 19"></polyline>
                        </svg>
                    </button>
                </div>

                <div class="footer-card">
                    <img src="/images/logo2.png" alt="Football Girl" class="footer-card-logo">
                    <p class="footer-card-text">The Home of Female Football</p>
                </div>
            </div>
        `;

        // Load AdSense script and trigger push
        if (!document.querySelector('script[src*="adsbygoogle.js"]')) {
            const s = document.createElement('script'); s.async = true; s.crossOrigin = "anonymous";
            s.src = "https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-7705230222200385";
            document.head.appendChild(s);
        }
        try { (window.adsbygoogle = window.adsbygoogle || []).push({}); } catch (e) {}

        // Attach event listener
        const backBtn = this.element.querySelector('#articleBackBtn');
        if (backBtn) {
            backBtn.addEventListener('click', (e) => {
                e.preventDefault();
                // Dispatch event for parent to handle navigation back
                const event = new CustomEvent('closeArticle', { bubbles: true });
                this.element.dispatchEvent(event);
            });
        }

        // Attach Sign In listener
        const signInBtn = this.element.querySelector('#signInBtn');
        if (signInBtn) {
            signInBtn.addEventListener('click', () => {
                this.isLoggedIn = true;
                this.render(); // Re-render to show form
            });
        }
        
        // Attach Post listener (if logged in)
        const postBtn = this.element.querySelector('.post-btn');
        if (postBtn) {
            postBtn.addEventListener('click', () => {
                const textarea = this.element.querySelector('.comment-textarea');
                if (textarea && textarea.value.trim()) {
                    alert('Comment posted! (Mock)');
                    textarea.value = '';
                }
            });
        }

        // Attach Previous Article listener
        const prevBtn = this.element.querySelector('#prevArticleBtn');
        if (prevBtn) {
            prevBtn.addEventListener('click', () => {
                const event = new CustomEvent('navigateArticle', { bubbles: true, detail: { index: this.navIndices.prev } });
                this.element.dispatchEvent(event);
            });
        }

        // Attach Next Article listener
        const nextBtn = this.element.querySelector('#nextArticleBtn');
        if (nextBtn) {
            nextBtn.addEventListener('click', () => {
                const anchors = ['wslnews', 'nwsl', 'apl', 'dfb', 'ligaf', 'seriea', 'wk', 'bpi', 'brasil', 'ligamx', 'nwfl', 'usl', 'we', 'saff', 'sweden', 'aleague'];
                if (anchors.includes(this.navIndices.next)) {
                    const event = new CustomEvent('navigateHome', { bubbles: true, detail: { anchor: this.navIndices.next } });
                    this.element.dispatchEvent(event);
                } else {
                    const event = new CustomEvent('navigateArticle', { bubbles: true, detail: { index: this.navIndices.next } });
                    this.element.dispatchEvent(event);
                }
            });
        }
    }
}